import React from 'react';
import './Team.css';
import { SocialIcon } from 'react-social-icons';
import Fade from 'react-reveal/Fade';
import { Dimensions } from '../../../Helper/sitedimension';

const mentor = (props) => {
    const { width } = Dimensions.useWindowDimensions();
    return (
        <div className={props.className} id="team">
            {width > 500 ?
                <div class="card-body card-body-cascade text-center">
                    <Fade delay={800}>
                        <img src={props.src} className="mentorimg" alt="mentor" />
                    </Fade>
                    <h4 class="name card-title"><Fade delay={800}>{props.name}</Fade></h4>
                    <h6 class="position "><Fade delay={800}>{props.position}</Fade></h6>
                    <Fade delay={1000}>
                        <div className="social">
                            <div className="social-icon"><SocialIcon url="http://facebook.com" network="facebook" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                            <div className="social-icon"><SocialIcon url="http://twitter.com" network="twitter" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                            <div className="social-icon"><SocialIcon url="http://instagram.com" network="instagram" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                            <div className="social-icon"><SocialIcon url="http://linkedin.com" network="linkedin" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                        </div>
                    </Fade>
                </div> :
                <div class="card-body card-body-cascade text-center">
                    <Fade delay={800}>
                        <img src={props.src} className="mentorimgtm" alt="mentor" />
                    </Fade>
                    <h4 class="nametm card-title"><Fade delay={800}>{props.name}</Fade></h4>
                    <h6 class="positiontm "><Fade delay={800}>{props.position}</Fade></h6>
                    <Fade delay={1000}>
                        <div className="row" style={{ width: "300px", position: "relative", top: "40px", left: "27px" }}>
                            <div className="social-icontm"><SocialIcon url="http://facebook.com" network="facebook" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                            <div className="social-icontm"><SocialIcon url="http://twitter.com" network="twitter" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                            <div className="social-icontm"><SocialIcon url="http://instagram.com" network="instagram" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                            <div className="social-icontm"><SocialIcon url="http://linkedin.com" network="linkedin" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                        </div>
                    </Fade>
                </div>
            }
        </div >
    )
}

export default mentor;